import Vue from "vue";
import Vuex from "vuex";

import keeps from "./modules/keeps";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        keeps,
    },
});